import { ICompany } from "@/api/mainPage/company/interface";
import { MutationTree } from "vuex";
import { IProfileState } from "./interface";
import { IProfileEntity } from "@/models/modules/profile/interface";
import { DigitalSign } from "@/feature/Auth/types/digital-sign";

export default <MutationTree<IProfileState>> {

	setProfile(state, newVal: IProfileEntity) {
		state.profile = newVal;
	},

	setCompany(state, newVal: ICompany | null) {
		state.company = newVal || null;
	},

	setDigitalSign(state, digitalSign: DigitalSign | null) {
		state.digitalSign = digitalSign;
	}

}